<template>
  <div>
    <title-bar title="菜单管理">
    </title-bar>
    <div class="page-body">
      <el-row :gutter="20">
        <el-col :span="6">
          <el-card header="菜单树" :body-style="{maxHeight: '500px', overflowY:'auto'}">
            <template slot="header">
              <div class="menu-header">
                <span>菜单树</span>
                <div>
                  <el-button type="text" @click="addRootMenu()">添加根菜单</el-button>
                  <el-button type="text" @click="addMenu()" :disabled="node == null || !node.data.menuId || !!node.data.url">添加子菜单</el-button>
                </div>
              </div>
            </template>
            <el-tree ref="tree" lazy :load="loadMenu"
                     node-key="id"
                     :props="menuProps"
                     @node-click="handleClick">
              <template slot-scope="{currentNode, data}">
                <div :class="data.valid?'':'color-gray'">
                  <i :class="data.iconClassName"></i>
                  {{ data.menuName }}
                  <i class="fa fa-check-circle color-primary" v-if="node != null && node.data.menuId == data.menuId"></i>
                </div>
              </template>
            </el-tree>
          </el-card>
        </el-col>
        <el-col :span="18">
          <el-card header="菜单编辑">
            <el-form ref="editForm" :model="menu" label-width="100px" :rules="validateRules"
                     style="width: 800px;margin:auto" v-if="menu != null">
              <el-form-item label="菜单名称" prop="menuName">
                <el-input v-model.trim="menu.menuName" clearable placeholder="请输入菜单名称"></el-input>
              </el-form-item>
              <el-form-item label="菜单地址" prop="url">
                <el-input v-model.trim="menu.url" clearable placeholder="请输入菜单地址"></el-input>
              </el-form-item>
              <el-form-item label="父菜单" prop="parentName">
                <el-input v-model="menu.parentName" disabled></el-input>
              </el-form-item>
              <el-form-item label="菜单图标" prop="iconClassName">
                <el-input v-model="menu.iconClassName" clearable placeholder="例如 fa fa-list"></el-input>
              </el-form-item>
              <el-form-item label="是否启用" prop="valid">
                <el-switch v-model="menu.valid"></el-switch>
              </el-form-item>
              <div class="button-container">
                <el-button type="primary" @click="save">保存</el-button>
                <el-button type="danger" @click="del">删除</el-button>
              </div>
            </el-form>
            <div v-else>
              请点击添加根菜单，或点击添加子菜单
            </div>
          </el-card>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import TitleBar from "@/components/base/TitleBar";
import TablePagination from "@/components/base/TablePagination";
import BaseVue from "@/components/base/BaseVue";
export default {
  components: {TablePagination, TitleBar},
  extends: BaseVue,
  data() {
    return {
      parentId: null,
      menu: null,
      //当前节点
      node: null,
      //根节点
      rootNode: null,
      menuProps: {
        // label: 'menuName',
        children: 'children',
        isLeaf: (data, node)=>{ return !!data.routeUrl || !!data.url}
      },
      validateRules: {
        menuName: [{required:true, message:'菜单名称不能为空', trigger: 'blur'}]
      }
    }
  },
  created() {
  },
  methods: {
    addRootMenu() {
      this.menu = {valid: true};
      this.node = this.rootNode;
    },
    addMenu() {
      let parentId = this.menu.menuId;
      let parentName = this.menu.menuName;
      this.menu = {valid: true, parentId: parentId, parentName: parentName};
    },
    handleClick(item, node, dom) {
      this.node = node;
      if(this.menu && this.menu.menuId == item.menuId) {
        return;
      }
      this.loading = true;
      this.postForm("/menu/getMenu", {
        menuId: item.menuId
      }, true).then(dr => {
        this.menu = dr.bean;
      }).finally(()=>{
        this.loading = false;
      })
    },
    loadMenu(node, resolve){
      if(this.rootNode == null) {
        this.rootNode = node;
      }
      let parentId = node.data ? node.data.menuId : null;
      this.loading = true;
      this.postForm("/menu/v2/getMenuList", {
        parentId: parentId
      }, true).then(dr => {
        resolve(dr.rows);
      }).finally(()=>{
        this.loading = false;
      })
    },
    save() {
      let isNew = !this.menu.menuId;
      this.loading = true;
      this.postForm("/menu/saveMenu", this.menu, true).then(dr => {
        this.menu = dr.bean;
        if(isNew) {
          this.node.loaded = false;
          this.node.expand();
        } else {
          Object.assign(this.node.data, dr.bean);
        }
        this.menu = null;
      }).finally(()=>{
        this.loading = false;
      })
    },
    del() {
      this.$confirm("确定要此菜单吗？").then(()=>{
        this.loading = true;
        this.postForm("/menu/deleteMenu", this.menu, true).then(dr => {
          //刷新父级菜单
          this.node.parent.loaded = false;
          this.node.parent.expand();
          this.node = null;
          this.menu = null;
        }).finally(()=>{
          this.loading = false;
        })
      });
    }
  }
}
</script>

<style scoped lang="scss">
.menu-header{
  display: flex;
  justify-content: space-between;
  align-items: center;
  .el-button{
    padding: 0px;
  }
}
</style>